import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import styles from './Layout.scss';

const ContentSkeleton = () => (
  <div className={styles.skeleton}>
    <Skeleton variant="rectangular" className={styles.skeletonSidebar} />
    <Skeleton variant="rectangular" />
    <Skeleton variant="rectangular" className={styles.skeletonContent} />
  </div>
);

export default ContentSkeleton;
